'use strict';

require('../groups/CompanyGroupCategoryService.js');

function CompanySettingCategoryGroupsCtrl(
  $scope,
  $q,
  groupCategories,
  translations,
  $stateParams,
  $state,
  $window,
  CompanyGroupCategoryService,
  growl
) {
  var origGroupCategories = [];

  $scope.translations = translations;
  $scope.groupCategories = groupCategories;

  function saveGroupCategory(groupCategory) {
    if( !groupCategory.id) {
      return groupCategory.$save({companyId: $stateParams.companyId}, function(groupCategory, headers) {
        groupCategory.id = headers("location").split("/").pop();

        growl.addSuccessMessage(translations['settings.create-group-category-success'] + ': ' + groupCategory.name);

        return groupCategory;
      });
    }

    for(var i = 0; i < origGroupCategories.length; i++) {
      if(origGroupCategories[i].id === groupCategory.id) {
        if(angular.equals(origGroupCategories[i], groupCategory)) {
          return $scope.createQ(function(resolve) {
            resolve(groupCategory);
          });
        }
        else {
          return groupCategory.$update({companyId: $stateParams.companyId});
        }
      }
    }

    return groupCategory.$update({companyId: $stateParams.companyId});
  }

  $scope.saveGroupCategories = function(){
    return $q.all($scope.groupCategories.map(saveGroupCategory)).then(function(groupCategories) {
      $scope.groupCategories = groupCategories;

      origGroupCategories = angular.copy($scope.groupCategories);

      $window.location.reload();

      growl.addSuccessMessage(translations['settings.create-group-category-success']);
    }, function(error) {
      if(error.status===304){
        growl.addSuccessMessage(translations['settings.create-group-category-success']);
      }else{
        growl.addErrorMessage(translations['settings.create-group-category-failure']);
      }
    });
  };

  $scope.addGroupCategory = function() {
    $scope.groupCategories.push(new CompanyGroupCategoryService());

    $scope.lastItem = $scope.groupCategories.length - 1;
  };

  $scope.deleteGroupCategory = function(groupCategory) {
    groupCategory.$delete({companyId: $stateParams.companyId, categoryId: groupCategory.id}, function() {
      function groupCategoryFilter(c) {
        return c.id !== groupCategory.id;
      }

      $scope.groupCategories = $scope.groupCategories.filter(groupCategoryFilter);
      origGroupCategories    = $scope.groupCategories.filter(groupCategoryFilter);

      growl.addSuccessMessage(translations['settings.remove-group-category-success']);
    },
    function() {
        growl.addErrorMessage(translations['settings.remove-group-category-failure']);
    });
  };
}

CompanySettingCategoryGroupsCtrl.resolve = {
  groupCategories: ['$stateParams', 'CompanyGroupCategoryService', function($stateParams, CompanyGroupCategoryService) {
    return CompanyGroupCategoryService.query({companyId: $stateParams.companyId, limit: 100}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'settings.create-group-category-success',
      'settings.create-group-category-failure',
      'settings.remove-group-category-success',
      'settings.remove-group-category-failure'
    ]);
  }]
};
module.exports = CompanySettingCategoryGroupsCtrl;

angular.module('dokiv')
  .controller('CompanySettingCategoryGroupsCtrl', [
  '$scope',
  '$q',
  'groupCategories',
  'translations',
  '$stateParams',
  '$state',
  '$window',
  'CompanyGroupCategoryService',
  'growl',
  CompanySettingCategoryGroupsCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingCategoryGroupsCtrl.js
// module id = 407
// module chunks = 0